import React from 'react';
import PropTypes from 'prop-types';

export default function ShopSimpleHeader({ customTitle, productTotal }) {
  const totalProductsDisplay = productTotal > 1 ? `${productTotal} Items` : `${productTotal} Item`;
  return (
    <div className="zola-shop__product-controls__title margin-bottom padding-left padding-right">
      {!!customTitle && <h2 className="zola-shop__category-title">{customTitle}</h2>}
      {!!productTotal && <span className="zola-shop__product-count">{totalProductsDisplay}</span>}
    </div>
  );
}

ShopSimpleHeader.propTypes = {
  customTitle: PropTypes.string,
  productTotal: PropTypes.number,
};
